import { MediaType } from '@confluence/graphql/entry-points/MediaType.ts';
import { useExperimentalMutation } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalMutation.ts';

import type {
	RemoveSpaceUnlicensedPermissionMutation,
	RemoveSpaceUnlicensedPermissionMutationVariables,
} from './__types__/SpaceUnlicensedPermissionMutation.ts';

export const useExperimentalRemoveUnlicensedPermissionMutation = ({
	update,
}: {
	update: (cache: null, result: { data?: RemoveSpaceUnlicensedPermissionMutation | null }) => void;
}): ReturnType<
	typeof useExperimentalMutation<
		RemoveSpaceUnlicensedPermissionMutation,
		RemoveSpaceUnlicensedPermissionMutationVariables,
		RemoveUnlicensedPermissionMutationResponse
	>
> => {
	return useExperimentalMutation<
		RemoveSpaceUnlicensedPermissionMutation,
		RemoveSpaceUnlicensedPermissionMutationVariables,
		RemoveUnlicensedPermissionMutationResponse
	>({
		url: (variables) =>
			`/wiki/rest/api/space/${variables.spaceKey}/permission/${variables.permissionId}`,
		method: 'DELETE',
		headers: {
			'Content-Type': MediaType.JSON,
		},
		parseResponseOnSuccess: (response) => ({
			success: response.status === 204,
		}),
		parseResult: (json) => ({
			experimentalRemoveUnlicensedPermission: {
				success: json.success,
			},
		}),
		update,
	});
};

interface RemoveUnlicensedPermissionMutationResponse {
	success: boolean;
}
